import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { Link, useHistory } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { DefaultLayout } from '../../layout/theme-customizer';
import tema from "../../services/Plantilla";

const id = window.location.pathname.split('/').pop()
  const defaultLayout = Object.keys(DefaultLayout);
  const layout = id ? id : defaultLayout
class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        nombre: '',
        descripcion: '',
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const { nombre, descripcion } = this.state;
        var errores = [];
        if (!nombre) { errores.push("error_nombre"); }
        if (!descripcion) { errores.push("error_descripcion"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
            nombre: nombre,
            descripcion: descripcion
        }
        authAxios.post("roles/registrar", datosEnviar)
            .then((datosRespuesta) => {
                
                const status = datosRespuesta.data.Status || datosRespuesta.data.status;
                
                if (status) {
                    Swal.fire({
                        title: 'Roles!',
                        text: datosRespuesta.data.msj || 'Rol creado exitosamente',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    }).then(() => {
                        // Redirigir usando history de las props
                         window.location.href = `/roles/lista/${tema}`;
                    });
                } else {
                    Swal.fire(
                        'Error!',
                        datosRespuesta.data.msj || 'Error al crear el rol',
                        'error'
                    );
                }

            })
            .catch()
    }
    render() {
        const { nombre, descripcion } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRO DE ROLES</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                                <div className="col-md-3">
                                                    <label htmlFor="nombre">Nombre</label>
                                                    <input style={{ textTransform: 'uppercase' }} className={((this.verificarError("error_nombre")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="nombre" id="nombre" value={nombre} placeholder="NOMBRE" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-6">
                                                    <label htmlFor="descripcion">Descripción</label>
                                                    <textarea style={{ resize: 'none', textTransform: 'uppercase' }} className={((this.verificarError("error_descripcion")) ? "is-invalid" : "") + ' form-control form-control-sm'} id="descripcion" name="descripcion" rows='3' onChange={this.cambioValor}></textarea>
                                                    <small id="helpId" className="invalid-feedback">Digite la Descripción</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear Rol</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={`${process.env.PUBLIC_URL}/roles/lista/${layout}`}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;